import React, { useEffect, useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import "./../../CompanysForm.css"
import { post, put } from "helpers/api_helper"
import Grid from "components/Common/Grid"

// Função para aplicar máscara de CNPJ
const formatCNPJ = (value) => {
  const numbers = value.replace(/\D/g, '')
  return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

const validationSchema = Yup.object({
  Ranking: Yup.string().required("Ranking é obrigatório."),
  CNPJ: Yup.string()
    .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, "CNPJ deve estar no formato XX.XXX.XXX/XXXX-XX.")
    .optional(),
  Empresa: Yup.string().optional(),
  UFSede: Yup.string()
    .length(2, "UF Sede deve ter exatamente 2 caracteres.")
    .matches(/^[A-Za-z]{2}$/, "UF deve conter apenas 2 letras.")
    .optional(),
  Setor: Yup.string().optional(),
  ReceitaLiquida: Yup.string()
    .matches(
      /^[0-9]+(,[0-9]{1,2})?$/,
      "Digite números e vírgula para separação decimal"
    )
    .optional(),
  PalavraChave: Yup.string().optional(),
  Lote: Yup.string().optional(),
  Status: Yup.string().optional(),
})

const RankingForm = ({
  companySelected,
  setCompanySelected,
  setShowList,
  setCurrentPage,
}) => {
  const [isLoadingCNPJ, setIsLoadingCNPJ] = useState(false)
  const initialValues = {
    CNPJ:
      companySelected !== null && companySelected.CNPJ !== null
        ? formatCNPJ(companySelected.CNPJ.replace(/\D/g, ''))
        : "",
    Ranking:
      companySelected !== null && companySelected.Ranking !== null
        ? companySelected.Ranking
        : "",
    Empresa:
      companySelected !== null && companySelected.Empresa !== null
        ? companySelected.Empresa
        : "",
    UFSede:
      companySelected !== null && companySelected.UFSede !== null
        ? companySelected.UFSede
        : "",
    Setor:
      companySelected !== null && companySelected.Setor !== null
        ? companySelected.Setor
        : "",
    ReceitaLiquida:
      companySelected !== null && companySelected.ReceitaLiquida !== null
        ? companySelected.ReceitaLiquida
        : "",
    PalavraChave:
      companySelected !== null && companySelected.PalavraChave !== null
        ? companySelected.PalavraChave
        : "",
    Lote:
      companySelected !== null && companySelected.Lote !== null
        ? companySelected.Lote
        : "",
    Status:
      companySelected !== null && companySelected.Status !== null
        ? companySelected.Status
        : "Ativo",
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      // Limpar máscara do CNPJ antes de enviar
      const cleanValues = {
        ...values,
        CNPJ: values.CNPJ ? values.CNPJ.replace(/\D/g, '') : "",
        Status: values.Status === "Ativo" ? true : false
      }
      
      if (companySelected === null) {
        handleCreateNewCompany(cleanValues)
      } else {
        handleEditCompany(cleanValues)
      }
    },
  })

  const handleCreateNewCompany = async payload => {
    const url =
      `${process.env.REACT_APP_API_INT_LEADS}/api/empresas-ranking`

    try {
      const response = await post(url, payload)
      console.log(response)
      alert("A empresa foi cadastrada com sucesso!")
      setShowList(true)
      setCurrentPage(1)
      return
    } catch (error) {
      if (error.response?.status === 400) {
        alert(error.response.data.message)
        return
      } else {
        alert(
          "Algo de errado aconteceu! Tente mais tarde ou verifique sua internet"
        )
        return
      }
    }
  }

  const handleEditCompany = async payload => {
    const url = `${process.env.REACT_APP_API_INT_LEADS}/api/empresas-ranking/${companySelected.Id}`

    try {
      const response = await put(url, payload)
      console.log(response)
      alert("A empresa foi editada com sucesso!")
      handleCancelEdditing()
      setCurrentPage(1)

      return
    } catch (error) {
      if (error.response?.status === 400) {
        alert(error.response.data.message)
        return
      } else {
        alert(
          "Algo de errado aconteceu! Tente mais tarde ou verifique sua internet"
        )
        return
      }
    }
  }

  const handleCancelEdditing = () => {
    setCompanySelected(null)
    setShowList(true)
  }

  // Função para buscar dados do CNPJ na API BrasilAPI
  const searchCNPJ = async cnpj => {
    setIsLoadingCNPJ(true)
    try {
      const response = await fetch(
        `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`
      )
      const data = await response.json()
      if (data && !data.message) {
        formik.setValues({
          ...formik.values,
          Empresa: data.razao_social || data.nome_fantasia || "",
          UFSede: data.uf || "",
        })
      } else {
        alert(data.message || "CNPJ não encontrado")
      }
    } catch (error) {
      alert("Erro ao buscar CNPJ. Verifique sua conexão.")
    } finally {
      setIsLoadingCNPJ(false)
    }
  }

  useEffect(() => {
    !companySelected && formik.resetForm({ values: initialValues })
  }, [companySelected])

  // useEffect para autopreenchimento quando CNPJ é inserido
  useEffect(() => {
    if (formik.values.CNPJ) {
      const cnpjNumbers = formik.values.CNPJ.replace(/\D/g, '')
      
      // Buscar dados da empresa quando CNPJ estiver completo
      if (cnpjNumbers.length === 14) {
        searchCNPJ(cnpjNumbers)
      }
    }
  }, [formik.values.CNPJ])

  return (
    <div className="companys-form-container">
      <h1 className="h1-form-title">Preencha o formulário abaixo:</h1>
      <span className="span-form-subtitle">Campos obrigatórios *</span>
      {companySelected !== null && (
        <span className="span-form-edditing">
          Atenção! Você está editando a empresa selecionada!
        </span>
      )}
      <form className="form-companys-container" onSubmit={formik.handleSubmit}>
        <Grid>
          <div className="input-and-label">
            <label className="company-label">CNPJ</label>
            <input
              className="company-input-field"
              type="text"
              name="CNPJ"
              placeholder="XX.XXX.XXX/XXXX-XX"
              value={formik.values.CNPJ}
              onChange={(e) => {
                const formattedValue = formatCNPJ(e.target.value)
                formik.setFieldValue('CNPJ', formattedValue)
              }}
              onBlur={formik.handleBlur}
              maxLength={18}
            />
            {isLoadingCNPJ && (
              <span className="span-form-loading">Buscando dados...</span>
            )}
            {formik.touched.CNPJ && formik.errors.CNPJ ? (
              <span className="span-form-error-companys">
                {formik.errors.CNPJ}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Ranking*</label>
            <input
              className="company-input-field"
              type="number"
              name="Ranking"
              value={formik.values.Ranking}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Ranking && formik.errors.Ranking ? (
              <span className="span-form-error-companys">
                {formik.errors.Ranking}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Empresa</label>
            <input
              className="company-input-field"
              type="text"
              name="Empresa"
              value={formik.values.Empresa}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Empresa && formik.errors.Empresa ? (
              <span className="span-form-error-companys">
                {formik.errors.Empresa}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">UF Sede</label>
            <input
              className="company-input-field"
              type="text"
              name="UFSede"
              value={formik.values.UFSede}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.UFSede && formik.errors.UFSede ? (
              <span className="span-form-error-companys">
                {formik.errors.UFSede}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Setor</label>
            <input
              className="company-input-field"
              type="text"
              name="Setor"
              value={formik.values.Setor}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Setor && formik.errors.Setor ? (
              <span className="span-form-error-companys">
                {formik.errors.Setor}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Receita líquida R$</label>
            <input
              className="company-input-field"
              type="text"
              name="ReceitaLiquida"
              value={formik.values.ReceitaLiquida}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="1500,50"
            />
            {formik.touched.ReceitaLiquida && formik.errors.ReceitaLiquida ? (
              <span className="span-form-error-companys">
                {formik.errors.ReceitaLiquida}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Lote</label>
            <input
              className="company-input-field"
              name="Lote"
              value={formik.values.Lote}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Lote && formik.errors.Lote ? (
              <span className="span-form-error-companys">
                {formik.errors.Lote}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Status</label>
            <select
              className="company-input-field"
              name="Status"
              value={formik.values.Status}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
            {formik.touched.Status && formik.errors.Status ? (
              <span className="span-form-error-companys">
                {formik.errors.Status}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Palavra chave</label>
            <input
              className="company-input-field"
              type="text"
              name="PalavraChave"
              value={formik.values.PalavraChave}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.PalavraChave && formik.errors.PalavraChave ? (
              <span className="span-form-error-companys">
                {formik.errors.PalavraChave}
              </span>
            ) : null}
          </div>
        </Grid>

        <Grid marginTop={32}>
          <button
            className="btn btn-primary w-md "
            type="submit"
            style={{ height: 40, border: "none" }}
          >
            Enviar
          </button>
          {companySelected !== null && (
            <button
              className="btn btn-primary w-md "
              type="button"
              style={{ backgroundColor: "red", height: 40, border: "none" }}
              onClick={handleCancelEdditing}
            >
              Cancelar
            </button>
          )}
        </Grid>
      </form>
    </div>
  )
}

export default RankingForm
